import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Tab, Tabs} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { withRouter } from '../../common/with-router';
import AsyncSelect from 'react-select/async';
import {FaCheck, FaEye } from "react-icons/fa";
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

class TiposProgramaEdit extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.enviaTipoPrograma = this.enviaTipoPrograma.bind(this);

        this.state = {
            nome: '',
            descricao: '',
            tipoHelper: '',
            nomeHelper: '',
            conteudoHelper: '',
            descricaoHelper: '',
            erroLoadRegistro: "",
            tipo_programa_id: "",
            titulo_pagina: "",
            loading: false,
        };
    }

    componentDidMount(){
        const id = this.props.router.params.id;

        if(id){
            this.setState({
                tipo_programa_id: id,
                titulo_pagina: 'Editando Tipos de Programa',
                loading: true,
                erroLoadRegistro: ''
            })

            //consulta os dados do programa na api
            api.get(`/programas/tipos/${id}`)
            .then(response => {
                const dados = response.data;

                //preenche os inputs
                this.setState({
                    erroLoadRegistro: '',
                    nome: dados.nome,
                    descricao: dados.descricao,
                    loading: false
                })
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar os tipos de programa, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
        else {
            this.setState({
                tipo_programa_id: '',
                titulo_pagina: 'Adicionar Tipos de Programa',
                loading: false,
                erroLoadRegistro: '',
            })
        }
    }

    enviaTipoPrograma = (e) => {
        e.preventDefault();

        const formData = new FormData();

        this.setState({
            loading: true,
            tipoHelper: "",
            descricaoHelper: "",
            nomeHelper: "",
            cidIdHelper: ""
        });

        //vererifica se é edição ou adição
        const url = (this.state.tipo_programa_id) ? '/programas/tipos/'+this.state.tipo_programa_id+'/' : '/programas/tipos/'
        const metodo = (this.state.tipo_programa_id) ? 'put' : 'post'

        formData.append('nome', this.state.nome);
        formData.append('descricao', this.state.descricao);
        
        //envia para api
        api({
            method: metodo,
            url: url,
            data: formData,
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.tipo_programa_id) ? 'Tipo de programa atualizado com sucesso' : 'Tipo de Programa cadastrado com sucesso';

            MySwal.fire({
                title: 'Sucesso!',
                html: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
            this.setState({
                loading: false,
            })
            
            //redireciona
            if(!this.state.tipo_programa_id){
                this.props.router.navigate("/tipos-programa");
            }
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar os tipos de programa, verifique os campos e tente novamente';               

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if (error.response.status === 400) {
                const campos = error.response.data;
            if (campos.slug && Array.isArray(campos.slug)) {
                erro_msg = campos.slug[0] || erro_msg;
            } else {
                erro_msg = 'Erro desconhecido no campo "slug"';
            }              
            
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key === 'nome'){
                        this.setState({ nomeHelper: value })
                    }
                    if(key === 'descricao'){
                        this.setState({ descricaoHelper: value })
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    render(){
        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Tabs defaultActiveKey="dadosTipos" id="tabs-tipos" className="aditus-tabs">
                    <Tab eventKey="dadosTipos" title="Dados dos Tipos de Programa">
                        <Card className="cardDestaque">
                            <Card.Body>                    
                                <Form onSubmit={this.enviaTipoPrograma}>
                                    <h4>Dados dos Tipos de Programa</h4>
                                    <Row>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Nome <span className="text-danger">*</span></Form.Label>
                                                <Form.Control type="text" name="nome" required placeholder="Nome do Tipo de Programa" value={this.state.nome} onChange={this.handleChange} />    
                                                <Form.Text id="formnomeHelper" className="text-danger">{this.state.nomeHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Descrição <span className="text-danger">*</span></Form.Label>
                                                <Form.Control type="text" name="descricao" required placeholder="Descrição do Tipo de Programa" value={this.state.descricao} onChange={this.handleChange} />    
                                                <Form.Text id="formdescricaoHelper" className="text-danger">{this.state.descricaoHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    {this.state.erroLoadRegistro ? 
                                    <Alert variant="warning">
                                        {this.state.erroLoadRegistro}
                                    </Alert> : ''
                                    }                                      
                                    <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                        {this.state.loading ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        ) : (
                                            <>
                                                <FaCheck className="me-1" /> Salvar
                                            </>
                                        )}
                                    </Button>
                                </Form> 
                            </Card.Body>                
                        </Card>
                    </Tab>
                </Tabs>
            </div>
        )
    }
}

export default withRouter(TiposProgramaEdit);